import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { Quote } from "lucide-react";
import SectionHeading from "../components/SectionHeading";


export default function CustomerTrapezoidSlider() {
  const customers = [
    {
      name: "علی رضایی",
      text: "اولین چیزی که منو شگفت‌زده کرد سرعت و دقت سفارش بود. کیفیت غذا دقیقاً مثل چیزی بود که در منو دیده بودم و کاملاً داغ به دستم رسید. بعد از چند بار سفارش، متوجه شدم که ثبات کیفیت مهم‌ترین ویژگی این مجموعه‌ست و همین باعث شده مشتری دائم‌شون بشم.",
      avatar: "/images/customers/avatar.png",
    },
    {
      name: "سارا محمدی",
      text: "من همیشه برای کافه‌ام دنبال راهی بودم که منو دیجیتال و حرفه‌ای داشته باشم. بعد از استفاده از این سرویس، نه تنها منو‌هام جذاب‌تر شد، بلکه مشتری‌هام هم خیلی راحت‌تر سفارش میدن. پشتیبانی فوق‌العاده سریع و محترمانه بود و واقعاً حس می‌کنی با یه تیم حرفه‌ای در ارتباطی.",
      avatar: "/images/customers/avatar.png",
    },
    {
      name: "مهدی جمشیدی",
      text: "چیزی که بیش از همه برام مهم بود، تجربه کاربری ساده برای مشتری‌هام بود. این سیستم دقیقاً همون چیزی بود که نیاز داشتم. همه‌چیز واضح، سریع و بدون پیچیدگی انجام می‌شه. قابلیت ویرایش منو و تغییر قیمت‌ها هم فوق‌العاده کاربردیه. واقعاً راضی‌ام و پیشنهادش می‌کنم.",
      avatar: "/images/customers/avatar.png",
    },

  ];

  return (
   
    <section className="container mx-auto px-4 py-16 text-center">
      <SectionHeading
        eyebrow="تجربه مشتریان"
        title="نقطه‌نظرات مشتریان مسیر موفقیت ما را روشن می‌کند."
        highlight="مسیر موفقیت"
      />
      <div className="relative mx-auto w-full max-w-3xl rounded-3xl border border-[#e3eeea] bg-white px-4 pb-6 pt-10 text-center shadow-[0_10px_30px_rgba(16,43,35,.06)] sm:px-8">
        <span
          className="absolute -top-6 left-1/2 grid h-12 w-12 -translate-x-1/2 place-items-center rounded-full bg-primary text-white ring-4 ring-white"
          aria-hidden="true"
        >
          <Quote size={20} />
        </span>
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 100000 }}
          loop={true}
          pagination={{ clickable: true }}
        >
          {customers.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="flex flex-col md:flex-row  justify-center gap-4 px-3 py-4 text-center ">
                <img
                  src={item.avatar}
                  className="mx-auto h-20 w-20 rounded-full ring-4 ring-[#eaf5f2] md:mx-0"
                  alt=""
                />
                <div className="flex flex-col justify-center text-default space-y-4">
                  <p className="leading-8 text-[#4a5a54]">
                    {item.text}
                  </p>
                  <div className="text-sm font-bold text-[#102b23]">
                    {item.name}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </section>




  );
}
